import React, { useContext } from 'react';

export const RadioGroupContext = React.createContext();

export const useRadioGroup = () => {
  return useContext(RadioGroupContext);
};
